export const stringEmptyOrWhitespaceOnly = (value: string | null) => {
  if (!value) {
    return true;
  }

  return !value.replace(/\s/g, '').length;
};
